<template>
  <div :class="container_class" :style="container_style">
    <multiselect
      v-model="task"
      @input="updateData"
      @remove="cleareData"
      :loading="isLoading"
      :options="tasks"
      :placeholder="place_holder"
      :clearOnSelect="false"
      :closeOnSelect="true"
      :preserveSearch="true"
      label="title"
      track-by="title"
    >
      <template slot="singleLabel" slot-scope="props">
        <div
          class="mr-1"
          style="font-size: 11px;white-space: nowrap;overflow: hidden;"
        >{{ props.option.title }}</div>
      </template>
      <template slot="option" slot-scope="props">
        <div>
          <span class="mr-1" style="font-size: 11px;">{{ props.option.title }}</span>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "trader-done-tasks",
  components: {
    Multiselect
  },
  props: {
    place_holder: {
      type: String,
      default: "Select a task"
    },
    container_class: {
      type: String,
      default: ""
    },
    container_style: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      task: null,
      tasks: [],
      isLoading: false
    };
  },
  created() {},
  mounted() {
    this.getTasks();
  },
  methods: {
    getTasks: function() {
      this.isLoading = true;
      let self = this;

      axios({
        method: "get",
        url: "/dashboard/task/trader-done-tasks"
      })
        .then(function(response) {
          self.isLoading = false;
          self.tasks = response.data.tasks;
        })
        .catch(function(err) {
          self.isLoading = false;
          self.errors = err.response.data.errors;
        });
    },
    updateData: function(value) {
      this.$emit("input", value.id);
    },
    cleareData: function() {
      this.$emit("input", null);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (
          this.task == null &&
          this.value != null &&
          this.value != undefined &&
          this.value != ""
        ) {
          let self = this;
          self.isLoading = true;
          axios({
            method: "get",
            url: "/dashboard/task/" + self.value
          })
            .then(function(response) {
              self.isLoading = false;
              self.task = response.data.task;
            })
            .catch(function(err) {
              self.isLoading = false;
              self.errors = err.response.data.errors;
            });
        }
      }
    }
  }
};
</script>
